import styled from "styled-components";

export const Scrollbar = styled.div`
  height: 87vh;
  ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    background: #f5f5f5;
  }
`;

export const Container = styled.main`
  margin-top: 36px;
  padding: 0 20px 0 20px;

  .modal-content {
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 0 20px 0 20px;
  }
`;

export const Title = styled.h1`
  color: #005ca5;
  font-size: 1.5625rem;
  font-weight: bold;
  margin-top: 50px;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    margin-left: 10.19px;
    color: #f0b01b;
  }

  ${Title} {
    color: #262626;
    font-size: 1.5625rem;
    font-weight: bold;
    margin: 0;
  }
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 15px 0px 15px 0px;
`;

export const Description = styled.span`
  color: #5e5e5e;
  display: block;
  margin-top: 20px;
  width: 100%;
  max-width: 320px;
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;

  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};

    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }
`;
